export const GOOGLE_DRIVE_FILE_SCOPE = 'https://www.googleapis.com/auth/drive.file';

export interface GoogleDriveUploadConfig {
  clientId: string;
  appId: string;
  developerKey: string;
}

export type GoogleDriveUploadFeatureConfig =
  | { status: 'disabled' }
  | { status: 'misconfigured' }
  | { status: 'enabled'; config: GoogleDriveUploadConfig };

type PublicEnvironment = Record<string, string | undefined>;

const readValue = (environment: PublicEnvironment, key: string): string => (
  String(environment[key] || '').trim()
);

export const readGoogleDriveUploadFeatureConfig = (
  environment: PublicEnvironment = process.env,
): GoogleDriveUploadFeatureConfig => {
  if (readValue(environment, 'REACT_APP_GOOGLE_DRIVE_UPLOAD_ENABLED').toLowerCase() !== 'true') {
    return { status: 'disabled' };
  }

  const values = {
    clientId: readValue(environment, 'REACT_APP_GOOGLE_DRIVE_CLIENT_ID'),
    appId: readValue(environment, 'REACT_APP_GOOGLE_DRIVE_APP_ID'),
    developerKey: readValue(environment, 'REACT_APP_GOOGLE_DRIVE_DEVELOPER_KEY'),
  };
  const hasMissingValue = [
    ['REACT_APP_GOOGLE_DRIVE_CLIENT_ID', values.clientId],
    ['REACT_APP_GOOGLE_DRIVE_APP_ID', values.appId],
    ['REACT_APP_GOOGLE_DRIVE_DEVELOPER_KEY', values.developerKey],
  ].some(([, value]) => !value);

  if (hasMissingValue) {
    return { status: 'misconfigured' };
  }
  return { status: 'enabled', config: values };
};

export const googleDriveUploadFeatureConfig = readGoogleDriveUploadFeatureConfig();
